// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EK88","left":"styles_left__1qg8P","desktopActions":"styles_desktopActions__v-HoJ","title":"styles_title__2y_Ao"};